<template>
  <v-container fluid class="menu-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Menu</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">New Menu</p>
                        <v-text-field
                          class="mb-4"
                          v-model="menu.menucode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Menu Code"
                          persistent-hint
                          single-line hint="Enter the menu code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="menu.menuname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Menu Name"
                          persistent-hint
                          single-line hint="Enter the menu name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="menu.menutype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the menu type">
                        </v-select>
                          <v-switch
                            v-model="menu.menustatus"
                            color="primary"
                            v-bind:label="menu.menustatus"
                            value="Active"
                          ></v-switch>
                        <div class="d-flex justify-end">

                        </div>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/menu/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertMenu()">
                            Save
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      menu: {menustatus: 'Active'},
      items: ['Menu', 'Other Menu'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Menu', ['insertMenuRequest', 'getMenusRequest']),
    checkError(){
      if(!this.menu.menucode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.menu.menuname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.menu.menutype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    async insertMenu() {
      if(!this.checkError()) return;
      await this.insertMenuRequest(this.menu);
      this.getMenusRequest();
      router.push('/menu/list');
    },
  },
  computed: {
    ...mapState('Menu', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
